import { render, staticRenderFns } from "./SharedGoalContentPage.vue?vue&type=template&id=ff8217ee&scoped=true"
import script from "./SharedGoalContentPage.vue?vue&type=script&lang=js"
export * from "./SharedGoalContentPage.vue?vue&type=script&lang=js"
import style0 from "./SharedGoalContentPage.vue?vue&type=style&index=0&id=ff8217ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8217ee",
  null
  
)

export default component.exports